export default [
  {
    name: 'Number',
    value: 'count',
    icon: 'fa-solid fa-input-numeric',
    img:'/icons/number-skeleton.png'
  },
  {
    name: 'Bar',
    value: 'bar',
    icon: 'fa-solid fa-chart-column',
    img:'/icons/bar-chart-skeleton.png'
  },
  // {
  //   name: 'Column',
  //   value: 'column',
  //   icon: 'fa-duotone fa-solid fa-chart-column',
  // },
  {
    name: 'Pie Chart',
    value: 'pie',
    icon: ' fa-solid fa-chart-pie',
    img:'/icons/pie-chart-legend.png'
  },
  {
    name: 'Donut Chart',
    value: 'donut',
    icon: ' fa-light fa-circle',
    img:'/icons/donut-chart-skeleton.png' 
  },
  {
    name: 'Bubble Chart',
    value: 'pie',
    icon: 'fa-solid fa-chart-pie',
  },
  {
    name: 'Area Chart',
    value: 'area',
    icon: 'fa-solid fa-chart-area',
    img:'/icons/area-chart-skeleton.png'
  },
  // {
  //   name: 'Line Chart',
  //   value: 'line',
  //   icon: 'fa-solid fa-chart-fft',
  //   img:'/icons/line-chart1-skeleton.png'
  // },
  {
    name: 'Table',
    value: 'table',
    icon: 'fa-thin fa-table-cells',
    img:'/icons/table-skeleton.png'
  },
];
